export const GET_COUNTRIES = 'settings/GET_COUNTRIES'
export const GET_COUNTRIES_SUCCESS = 'settings/GET_COUNTRIES_SUCCESS'
export const GET_COUNTRIES_FAIL = 'settings/GET_COUNTRIES_FAIL'

export const settingsGetCountries = payload => ({
  type: GET_COUNTRIES,
  payload
})

export const settingsGetCountriesSuccess = payload => ({
  type: GET_COUNTRIES_SUCCESS,
  payload
})

export const settingsGetCountriesFail = payload => ({
  type: GET_COUNTRIES_FAIL,
  payload
})
